export enum NotificationType {
  ABSENCE_STATUS_CHANGED = 'ABSENCE_STATUS_CHANGED',
  ABSENCE_CREATED = 'ABSENCE_CREATED',
  NEW_FORUM_THREAD = 'NEW_FORUM_THREAD',
  FORUM_THREAD_RESPONSE = 'FORUM_THREAD_RESPONSE',
  USER_DOCUMENT_ABOUT_TO_EXPIRE = 'USER_DOCUMENT_ABOUT_TO_EXPIRE',
  EXPORT_COMPLETED = 'EXPORT_COMPLETED',
  NEW_INFRINGEMENT = 'NEW_INFRINGEMENT',
  ISSUE_REMINDER = 'ISSUE_REMINDER',
  ANY = '*',
}

export enum APP_NOTIFICATION_STATUS {
  SEEN = 'SEEN',
  UNSEEN = 'UNSEEN',
  INTERACTED = 'INTERACTED',
  ARCHIVED = 'ARCHIVED',
}
